import React, {useEffect} from 'react';
import { Router } from 'react-router-dom';
import history from './services/history';
import Routes from './routes/index';

import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate0 from "react-alert-template-basic";
import AlertTemplate from "./components/AlertTemplate";

import store from './flux/store';
import { Provider } from 'react-redux';
import { loadUser } from './flux/actions/authActions';
import { refreshToken } from './flux/actions/authActions';

import HttpsRedirect from 'react-https-redirect';

import jwt from 'jsonwebtoken';
import { REFRESH_AUTH_TOKEN } from './flux/types';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_AXIOS_URL || "/";
axios.interceptors.request.use(async (config) => {
  if(config.headers && config.headers["x-auth-token"]/* && config.url !== "/api/auth/refreshToken"*/){
    const token = config.headers["x-auth-token"];
    const decodedToken = jwt.decode(token);
    const nowInSeconds = Math.floor(Date.now() / 1000);
    const tokenNeedsRefresh = decodedToken['exp'] > nowInSeconds && decodedToken['exp'] - nowInSeconds < 60 * 60 * 1;//3
    if(tokenNeedsRefresh){
      const newTokenRes = await refreshToken(decodedToken.id);
      if(config.headers)
        config.headers["x-auth-token"] = newTokenRes.token
      store.dispatch({
        type: REFRESH_AUTH_TOKEN,
        payload: {token: newTokenRes.token}
      })
    }
  }
  return config;
}, (error) => {
  // console.error("✉️ ", error);
  return Promise.reject(error);
});

function App() {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  React.useEffect(() => {
    function checkTokenValidity() {
      const token = localStorage.getItem('token')
      store.dispatch({
        type: REFRESH_AUTH_TOKEN,
        payload: {token}
      })
    }
  
    window.addEventListener('storage', checkTokenValidity)
  
    return () => {
      window.removeEventListener('storage', checkTokenValidity);
    }
  }, [])

  const alertOptions = {
    timeout: 4000,
    position: positions.BOTTOM_CENTER,
    containerStyle: {
      zIndex: 999999999
    }
  };

  return (<HttpsRedirect disabled={false/*process.env.NODE_ENV !== 'production'*/}>
    <Router history={history}>
      <AlertProvider template={AlertTemplate} {...alertOptions}>
        <Provider store={store}>
          <Routes />
        </Provider>
      </AlertProvider>
    </Router></HttpsRedirect>
  );
}

export default App;